/**
 * This enum is used to define the different filters that can be applied to the items
 */
export enum ItemFilters {
  NEEDS_REVIEW = 'Needs Review',
  ACCEPTED = 'Accepted',
  PENDING_VENDOR = 'Pending Vendor',
  PO_DRAFTS = 'PO Drafts',
  MANAGER_REVIEW = 'Manager Review',
  FINAL_REVIEW = 'Final Review',
  PO_CREATED = 'PO Created',
  REJECTED = 'Rejected',
  ALL = 'All',
}
